// extracted by mini-css-extract-plugin
module.exports = {"cell":"ColumnCell_cell__JRh5q"};